import CollectionWithHelpers from 'app/scripts/models/collections/internal/collection-with-helpers.coffee';
import { CustomEmoji } from 'app/scripts/models/CustomEmoji';

class CustomEmojiList extends CollectionWithHelpers {
  static initClass() {
    this.prototype.model = CustomEmoji;
  }
  url() {
    return `/1/member/${this.member.id}/customEmoji`;
  }

  // @ts-ignore
  initialize(list, { member }) {
    this.member = member;
  }
}
CustomEmojiList.initClass();

export { CustomEmojiList };
